import { Dayjs } from 'dayjs'

import { add } from './addAndSubtract'
import { isWeekend } from './isWeekend'

export const getNextWeekdays = (date: Dayjs, count: number): Dayjs[] => {
    const weekdays: Dayjs[] = []
    let currentDate = date

    while (weekdays.length < count) {
        if (!isWeekend(currentDate)) {
            weekdays.push(currentDate)
        }
        currentDate = add(currentDate, 1, 'day')
    }

    return weekdays
}
